import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RackZoneEmpData } from './rack-zone-emp-data-for-id';
import { RackZoneMappingDTo } from './rack-zone-mapping.dto';


export class RackZonemapResponse extends GlobalResponseObject{
    data?: RackZoneEmpData;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RackZoneEmpData) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 